module.exports = __webpack_public_path__ + "images/13b69ed1fdb622a35455b5ced4935b481bf3a1e30590bccc936be5418b6ccfac.svg";